export const INITIALIZE_PLATFORM_PAGE = 'initialize-platform-page';
const initializePlatformPage = () => ({ type: INITIALIZE_PLATFORM_PAGE });
export default initializePlatformPage;
